import { ChangePasswordViewModel } from '@apis/model';
import { toCaptchaViewModel, toMemberInfoViewModel } from '@apis/responseTransformer';
import { ChangePasswordResponse } from '@ul/api';

export const toChangePasswordViewModel = (changePasswordResponse: ChangePasswordResponse): ChangePasswordViewModel => {
    const { success, responseCode } = changePasswordResponse;
    return {
        responseCode,
        success,
        memberInfo: toMemberInfoViewModel(changePasswordResponse),
        captchaViewModel: toCaptchaViewModel(changePasswordResponse),
    };
};
